<app-search-bar-with-filters
  [searchBarText]="'Поиск по сотрудникам'"
  [isNeedFiltersButton]="currentEmployeesPageType === employeesPageType.allEmployees"
  [isCheckboxType]="currentEmployeesPageType === employeesPageType.allEmployees"
></app-search-bar-with-filters>
@if (employeesList$ | async; as employeesList) {
  <app-pagination-container
    (emitScrolling)="getEmployees($event)"
    [isLoading$]="isLoading$"
    [isAllLoaded]="isAllEmployeesListFetched$ | async"
    [paginationData]="employeesList"
    [listName]="listName"
    [clearListAction]="clearList"
    [noDataText]="
      (employeesList.length && isShowDirector) || (director && isShowDirector) ? '' : noDataText
    "
  >
    @if (
      currentEmployeesPageType === employeesPageType.additionalEmployees &&
      director &&
      isShowDirector
    ) {
      <app-employee-card [employee]="director" [id]="director.id"></app-employee-card>
    }
    @for (employee of employeesList; track trackByFn($index, employee)) {
      <div>
        @if (director?.id !== employee.id) {
          <app-employee-card
            [class.all-employees]="currentEmployeesPageType === employeesPageType.allEmployees"
            [employee]="employee"
            [id]="employee.id"
            [isShowDepartment]="currentEmployeesPageType === employeesPageType.allEmployees"
          ></app-employee-card>
        }
      </div>
    }
  </app-pagination-container>
}
